"use client";

import SomeWatchDogInfo from "@/components/index/sections/about/SomeWatchDogInfo";
import SomeWatchDogText from "@/components/index/sections/about/SomeWatchDogText";

const About3 = () => {
  return (
    <div className="about3-root">
      <SomeWatchDogText />
      <SomeWatchDogInfo />
    </div>
  );
};

export default About3;
